<template>
  <section class="app-main">
    <div class="top-bar">
      <el-input
        v-model="title"
        @change="handleTitle"
        placeholder="输入订单号查询"
        prefix-icon="el-icon-search"
        clearable
        style="width: 240px; margin: 0 20px 15px 0"
      >
      </el-input>
      <el-date-picker
        v-model="date"
        @change="handleDate"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        style="width: 260px; margin: 0 20px 15px 0"
      ></el-date-picker>
      <el-select
        v-model="checkItem"
        @change="handleType"
        clearable
        multiple
        collapse-tags
        placeholder="支付方式筛选"
        style="width: 240px"
      >
        <el-option label="支付宝" value="1"> </el-option>
        <el-option label="微信" value="2"> </el-option>
        <el-option label="VISA/Master" value="3"> </el-option>
        <el-option label="Paypal" value="4"> </el-option>
        <el-option label="现金" value="5"> </el-option>
        <el-option label="EMT" value="6"> </el-option>
        <el-option label="小程序" value="7"> </el-option>
        <el-option label="银联" value="8"> </el-option>
      </el-select>

      <el-select
        v-model="wayItem"
        @change="handleType"
        clearable
        multiple
        collapse-tags
        placeholder="购买途径筛选"
        style="width: 240px; margin-left: 20px"
      >
        <el-option label="线上商城" value="0"> </el-option>
        <el-option label="线下门店" value="1"> </el-option>
      </el-select>
      <!-- <el-button type="success" plain @click="excel" style="width:150px;margin-left:30px;">Export</el-button> -->
      <div>
        <el-tag type="success"
          >退款总计：C${{ totalMoney.CAD.total_refund_amount }} + US${{totalMoney.USD.total_refund_amount}}</el-tag
        >
        <el-tag type="success"
          >当页总计：C${{ totalMoney.CAD.current_page_amount }} + US${{totalMoney.USD.total_refund_amount}}</el-tag
        >
        <el-tag v-show="checkItem.includes('1')" type="primary"
          >支付宝：C${{ totalMoney.CAD.alipay_amount }} + US${{totalMoney.USD.total_refund_amount}}</el-tag
        >
        <el-tag v-show="checkItem.includes('2')" type="success"
          >微信：C${{ totalMoney.CAD.wechat_amount }} + US${{totalMoney.USD.total_refund_amount}}</el-tag
        >
        <el-tag v-show="checkItem.includes('3')" type="danger"
          >VISA/Master：C${{ totalMoney.CAD.card_amount }} + US${{totalMoney.USD.total_refund_amount}}</el-tag
        >
        <el-tag v-show="checkItem.includes('4')" type="danger"
          >Paypal：C${{ totalMoney.CAD.paypal_amount }} + US${{totalMoney.USD.total_refund_amount}}</el-tag
        >
        <el-tag v-show="checkItem.includes('5')" type="danger"
          >现金：C${{ totalMoney.CAD.cash_amount }} + US${{totalMoney.USD.total_refund_amount}}</el-tag
        >
        <el-tag v-show="checkItem.includes('6')" type="danger"
          >EMT：C${{ totalMoney.CAD.emt_amount }} + US${{totalMoney.USD.total_refund_amount}}</el-tag
        >
      </div>
    </div>

    <!-- 商品列表 -->
    <el-card>
      <el-table ref="table" :data="tableData" :cell-style="handleCell" height="500">
        <el-table-column label="日期" width="165" align="center">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ scope.row.created_at }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="order_title" label="订单号" align="center" min-width="185"></el-table-column>
        <el-table-column prop="phone" label="联系方式" align="center" width="180">
          <template slot-scope="scope">{{
            scope.row.phone == "" ? scope.row.email : scope.row.phone
          }}</template>
        </el-table-column>
        <el-table-column prop="pay_method_title" label="支付方式" align="center" >
          <template slot-scope="scope">
            <span>{{scope.row.pay_method_title == '-' ? '小程序' : scope.row.pay_method_title}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="way" label="购买途径" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.way == 1">线下门店</span>
            <span v-else>线上商城</span>
          </template>
        </el-table-column>
        <el-table-column prop="order_total_amount" label="实付金额" align="center">
          <template slot-scope="scope">
            {{scope.row.transaction && scope.row.transaction.trans_currency == 'USD'?'US$': 'C$'}}{{scope.row.order_total_amount}}
          </template>
        </el-table-column>
        <el-table-column prop="total_goods_price" label="商品退款" align="center">
          <template slot-scope="scope">
            {{scope.row.transaction && scope.row.transaction.trans_currency == 'USD'?'US$': 'C$'}}{{scope.row.total_goods_price}}
          </template>
        </el-table-column>
        <el-table-column prop="total_wallet_price" label="钱包退款" align="center">
          <template slot-scope="scope">
            {{scope.row.transaction && scope.row.transaction.trans_currency == 'USD'?'US$': 'C$'}}{{scope.row.total_wallet_price}}
          </template>
        </el-table-column>
        <el-table-column prop="total_tax_price" label="税费退款" align="center">
          <template slot-scope="scope">
            {{scope.row.transaction && scope.row.transaction.trans_currency == 'USD'?'US$': 'C$'}}{{scope.row.total_tax_price}}
          </template>
        </el-table-column>
        <el-table-column prop="total_freight_price" label="邮费退款" align="center">
          <template slot-scope="scope">
            {{scope.row.transaction && scope.row.transaction.trans_currency == 'USD'?'US$': 'C$'}}{{scope.row.total_freight_price}}
          </template>
        </el-table-column>
        <el-table-column prop="total_price" label="总计退款" align="center">
          <template slot-scope="scope">
            {{scope.row.transaction && scope.row.transaction.trans_currency == 'USD'?'US$': 'C$'}}{{scope.row.total_price}}
          </template>
        </el-table-column>
        <el-table-column prop="actual_total_price" label="实退金额" align="center">
          <template slot-scope="scope">
            {{scope.row.transaction && scope.row.transaction.trans_currency == 'USD'?'US$': 'C$'}}{{scope.row.actual_total_price}}
          </template>
        </el-table-column>
        <el-table-column prop="refund_status_title" label="退款状态" align="center" width="150">
          <template slot-scope="scope">
            <el-link
              v-if="scope.row.refund_status == 1"
              type="success"
              plain
              size="mini"
              >退款成功</el-link
            >
            <el-button
              v-else
              @click="showRefund(scope.row)"
              type="danger"
              plain
              size="small"
              >点击退款</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="totalMoney" label="订单详情" align="center">
          <template slot-scope="scope">
            <el-popover placement="top-end" width="1200" trigger="click">
              <el-table :data="scope.row.order_goods_all" max-height="300">
                <el-table-column label="商品图片" align="center">
                  <template slot-scope="scope">
                    <m-img
                      v-if="scope.row.goods_sku_pic_url"
                      :src="scope.row.goods_sku_pic_url"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  label="商品名称"
                  show-overflow-tooltip
                  align="center"
                >
                  <template slot-scope="scope">{{
                    scope.row.goods_name
                  }}</template>
                </el-table-column>
                <el-table-column
                  label="商品规格"
                  align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">{{
                    scope.row.sku_name
                  }}</template>
                </el-table-column>
                <el-table-column label="条形码" align="center">
                  <template slot-scope="scope">{{
                    scope.row.barcode
                  }}</template>
                </el-table-column>
                <el-table-column label="退货数量" align="center">
                  <template slot-scope="scope">{{
                    scope.row.after_sales_number
                  }}</template>
                </el-table-column>
                <el-table-column label="商品总计" align="center">
                  <template slot-scope="scope">{{scope.row.transaction && scope.row.transaction.trans_currency == 'USD'?'US$': 'C$'}}{{
                    scope.row.goods_price
                  }}</template>
                </el-table-column>
                <el-table-column label="税费总计" align="center">
                  <template slot-scope="scope">{{scope.row.transaction && scope.row.transaction.trans_currency == 'USD'?'US$': 'C$'}}{{
                    scope.row.goods_tax_price
                  }}</template>
                </el-table-column>
              </el-table>
              <el-button slot="reference" type="primary" plain size="mini"
                >查看详情</el-button
              >
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="reloadData"
        layout="prev, pager, next"
        style="padding: 15px"
        :total="total"
      ></el-pagination>
    </el-card>

    <el-dialog title="退款" :visible.sync="refund_model" center width="600px">
      <el-row class="row-h m-bottom-4">
        <el-col :span="4">选择退款：</el-col>
        <el-col :span="20">
          <el-checkbox-group v-model="refunds" @change="handleMoney(1)">
            <el-checkbox label="1" border>退商品</el-checkbox>
            <el-checkbox label="2" border>退税费</el-checkbox>
            <el-checkbox label="3" border>退邮费</el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>
      <el-row class="row-h m-bottom-4">
        <el-col :span="4">自行退款：</el-col>
        <el-col :span="20">
          <el-input
            v-model="money"
            @input="handleMoney(2)"
            placeholder="请输入退款金额"
            style="width: 374px"
          ></el-input>
        </el-col>
      </el-row>
      <el-row class="row-h m-bottom-4">
        <el-col :span="4">退款总计：</el-col>
        <el-col :span="20" style="font-size: 16px; color: red"
          >{{row.transaction && row.transaction.trans_currency == 'USD'?'US$': 'C$'}}{{ refundMoney.toFixed(2) }}</el-col
        >
      </el-row>
      <el-row type="flex" justify="center">
        <el-button
          type="info"
          plain
          style="margin-right: 30px"
          @click="refund_model = false"
          >取消退款</el-button
        >
        <el-button
          type="success"
          plain
          style="margin-left: 30px"
          @click="onRefund()"
          >确认退款</el-button
        >
      </el-row>
    </el-dialog>
  </section>
</template>



<script>
import { refund, refund_submit } from "@/api/platform.js";
import MImg from "./../../../components/Image";
export default {
  components: { MImg },
  data() {
    return {
      date: [],
      title: "",
      checkItem: [],
      wayItem: [],
      tableData: [],
      status: 0,
      total: 0,
      page: 1,
      totalMoney: {
        CAD: {
          total_pay_amount: "0.00",
          total_refund_amount: "0.00",
          current_total_amount: "0.00",
          current_page_amount: "0.00",
          alipay_amount: "0.00",
          wechat_amount: "0.00",
          card_amount: "0.00",
          paypal_amount: "0.00",
        },
        USD: {
          total_pay_amount: "0.00",
          total_refund_amount: "0.00",
          current_total_amount: "0.00",
          current_page_amount: "0.00",
          alipay_amount: "0.00",
          wechat_amount: "0.00",
          card_amount: "0.00",
          paypal_amount: "0.00",
        }
      },

      row: {},
      refund_model: false,
      refunds: [],
      money: "",
      refundMoney: 0,
    };
  },
  methods: {
    getData() {
      let params = {
        page: this.page,
      };
      if (this.checkItem.length != 0) {
        params.pay_search = this.checkItem.join(",");
      }
      if (this.wayItem.length != 0) {
        params.way_search = this.wayItem.join(",");
      }
      if (this.title != "") {
        params.title_search = this.title;
      }
      if (this.date.length != 0) {
        params.start_date_search = this.date[0];
        params.end_date_search = this.date[1];
      }
      refund(params).then((res) => {
        if (res) {
          this.tableData = res.data.list.data;
          this.tableData.forEach(item => {
            item.order_goods_all.forEach(it => {
              it.transaction = item.transaction
            })
          })
          this.total = res.data.list.total;
          this.table_load = false;
          this.totalMoney.CAD = res.data.statistics.CAD;
          if(res.data.statistics.USD) {
            this.totalMoney.USD = res.data.statistics.USD;
          }
        } else {
          this.tableData = [];
        }
      });
    },
    // 订单号搜索
    handleTitle() {
      this.checkItem = [];
      this.date = [];
      this.page = 1;
      this.getData();
    },
    // 日期查询搜索
    handleDate() {
      this.title = "";
      this.page = 1;
      this.getData();
    },

    // 支付方式搜索
    handleType() {
      this.title = "";
      this.page = 1;
      this.getData();
    },
    handleSelect(rows) {
      this.checkData = rows;
    },
    // 点击页数 加载当前点击页的数据
    reloadData(page) {
      this.page = page;
      this.getData();
    },

    // 设置cell 格式
    handleCell(obj) {
      if ([3, 7].includes(obj.columnIndex)) {
        return "color:red";
      }
    },

    // 显示退款弹窗
    showRefund(row) {
      this.refunds = [];
      this.refundMoney = 0;
      this.money = "";
      this.row = row;
      this.refund_model = true;
    },

    // 退款金额发生改变
    handleMoney(index) {
      this.refundMoney = 0;
      if (index == 1) {
        this.money = "";
        if (this.refunds.includes("1")) {
          console.log(this.row);
          this.refundMoney += this.row.total_goods_price - 0;
        }
        if (this.refunds.includes("2")) {
          this.refundMoney += this.row.total_tax_price - 0;
        }
        if (this.refunds.includes("3")) {
          this.refundMoney += this.row.total_freight_price - 0;
        }
      } else {
        this.refunds = [];
        this.refundMoney = this.money - 0;
      }
    },

    //提交退款
    onRefund() {
      console.log(this.refunds);
      if (this.refunds.length == 0 && this.money == "") {
        this.$message.error("请先选择退款或输入退款金额");
        return false;
      }
      let params = { refund_id: this.row.id };
      if (this.refunds.length != 0) {
        params.refund_options = this.refunds.join(",");
      }
      if (this.money != "") {
        params.refund_amount = this.money;
      }
      refund_submit(params)
        .then((res) => {
          if (res) {
            this.getData();
            this.$message({
              type: "success",
              message: res.msg,
              duration: 1500,
            });
            this.row = {};
            this.money = "";
          }
        })
        .finally(() => {
          this.refund_model = false;
          this.row = {};
          this.money = "";
        });
    },
  },
  created() {
    this.getData();
  },
  activated() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
section {
  /deep/ .el-tag + .el-tag {
    margin-left: 20px;
  }
  .row-h {
    height: 40px;
    line-height: 40px;
  }
  .col-flex {
    display: flex;
    align-items: center;
  }
}
</style>
